import { useSidebarConfig } from 'modules/common/hooks/sidebar/useSidebarConfig'
import { PropsWithChildren } from 'react'
import { SidebarContextProvider } from './SidebarContext'

export const SidebarWithConfigContext = ({ children }: PropsWithChildren) => {
  const { menus } = useSidebarConfig()

  return (
    <SidebarContextProvider menus={menus}>{children}</SidebarContextProvider>
  )
}
